export const refundRuleObj = {
    '/': { // 抖音
        text: 
`<p style=" font-size:12px;padding-left:12px">退款规则：
<b>节点判断：</b>
    待履约：支付7天内且未开始学习
    履约中：支付7天内或观看小于30分钟
    履约完成：观看满30分钟或支付后满7天
<b>退款规则：</b>
    待履约全额退，无需开发者审核
    履约中全额退，无需开发者审核
    履约完成协商退，需开发者审核</p>`
    },
    '/dd/': { // 
        text: 
`<p style=" font-size:12px;padding-left:12px">退款规则：
    <b>学员购买后未兑换核销。</b></p>`
    },
    'other': { // 其他
        text: 
`<p style=" font-size:12px;padding-left:12px">退款规则：
<b>1、音视频课程——互联网产品与运营/电子商务，修图、音视频，短视频类目</b>
支付7日内学习时长&lt;30分钟可全额退款
<b>2、音视频课程——其他类目课程</b>
支付7日内学习时长&lt;10分钟可全额退款
<b>3、图文类型课程</b>
支付7日内且用户未开始学习可全额退款</p>`
    }
}